import ActivateCouponError from './ActivateCouponError';
class ActivateCouponInvalidPropertyId extends ActivateCouponError {
    propertyId;
    constructor(propertyId, options) {
        super('The crowdfunding property id is not in uuid format', options);
        this.propertyId = propertyId;
    }
}
export default ActivateCouponInvalidPropertyId;
